import script from "./PostFBView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostFBView.vue?vue&type=script&setup=true&lang=js"

import "./PostFBView.vue?vue&type=style&index=0&id=eb54ff3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb54ff3c"]])

export default __exports__